angular.module("core")
.component("formatInvoiceNumber", {
    templateUrl: require("./format-invoice-number.component.html"),
    bindings: {
        number: "<"
    },
    controller: function($scope, $controller) {
        var lengthIndexMapping = {
            3: 1,
            4: 2,
            5: 2
        }
        angular.extend(this, $controller("abstractFormatNumberController", {
            _this: this,
            $scope: $scope,
            lengthIndexMapping: lengthIndexMapping
        }));
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/format-number/format-invoice-number/format-invoice-number.component.js
// module id = 649
// module chunks = 0